// Submitted-settings snapshot for an "Animate Image" (api/animation/v2) job.
//
// ImageAnimatorModal used to render the Üret step's provider/süre/döngü chips
// from the LIVE form state. That state is not stable while a job runs: the
// open-transition effect resets provider→gemini and duration→scene default,
// the saved-job loader re-reads loop from localStorage, and the version
// restore pass can rewrite all three. So a pixverse/5 s job showed as
// "Gemini · 8 sn" after a close/reopen. The fix is to pin what was actually
// sent onto the job (state + localStorage) and read it back from there.
//
// buildAnimateJobSettings mirrors handleSubmit's durationSec rule exactly so
// the snapshot IS the request: an explicit pick wins; "Otomatik" resolves to
// the provider's nearest allowed length for a play-once clip with a known
// scene window, to 4 s on the Veo (gemini) family, and stays null (server
// default) everywhere else.

import { nearestAllowedDuration } from "./animationDurationOptions.es6";

const GEMINI_FAMILY = ["gemini", "gemini-fast"];

export function buildAnimateJobSettings({ provider, duration, loop, prompt, elementWindowSec }) {
  let durationSec;
  if (duration !== null && duration !== undefined) {
    durationSec = duration;
  } else if (loop === false && typeof elementWindowSec === "number") {
    durationSec = nearestAllowedDuration(provider, elementWindowSec);
  } else if (GEMINI_FAMILY.includes(provider)) {
    durationSec = 4;
  } else {
    durationSec = null;
  }
  return {
    provider,
    durationSec,
    loop: !!loop,
    prompt: typeof prompt === "string" ? prompt : "",
  };
}

// What the Üret / result step should display for `job`. Snapshot fields win;
// each missing one falls back to the live form (older persisted jobs predate
// the snapshot) — loop additionally to the `job.loop` stamp handleSubmit has
// always written, provider additionally to what the backend reported.
export function resolveAnimateDisplaySettings(job, live = {}) {
  const s = (job && job.settings) || {};
  const provider = s.provider || (job && job.result && job.result.provider) || live.provider;
  const durationSec =
    typeof s.durationSec === "number"
      ? s.durationSec
      : typeof live.duration === "number"
        ? live.duration
        : null;
  const loop =
    typeof s.loop === "boolean"
      ? s.loop
      : job && typeof job.loop === "boolean"
        ? job.loop
        : !!live.loop;
  const prompt = typeof s.prompt === "string" ? s.prompt : live.prompt || "";
  return { provider, durationSec, loop, prompt };
}
